import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { LyearnLogo } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Image } from '@/components/Image';
import { useAppConfig } from '@/hooks/useAppConfig';

function SidebarHeader({
  className,
  collapsed = false,
}: {
  className?: string;
  collapsed?: boolean;
}) {
  const { t } = useTranslation();
  const { site } = useAppConfig();
  const { logoUrl, appUrl, appUrlTarget, name } = site;

  const logoClassName = cn(
    'max-h-[2.4rem] w-auto rounded-4 object-contain transition-all duration-300 ease-in-out',
    collapsed && 'max-w-[2.4rem]',
  );

  return (
    <div
      className={cn(
        'flex h-50 flex-shrink-0 items-center transition-[padding] duration-300 ease-in-out',
        collapsed ? 'ps-16' : 'ps-12',
        className,
      )}>
      <a
        className="inline-flex h-28 items-center"
        href={appUrl || '/'}
        rel="noreferrer"
        target={appUrlTarget}>
        {logoUrl ? (
          <Image
            useImg
            alt={t('Common:LogoOfImage', { imageAlt: name })}
            className={logoClassName}
            src={logoUrl}
          />
        ) : (
          <LyearnLogo className={logoClassName} fill="currentColor" />
        )}
      </a>
    </div>
  );
}

export default React.memo(SidebarHeader);
